"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textArea = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-area"));

var UserNotes = function UserNotes(_ref) {
  var userNotes = _ref.userNotes,
      onChangeUserNoteInput = _ref.onChangeUserNoteInput,
      userNoteInput = _ref.userNoteInput,
      errors = _ref.errors,
      addUserNote = _ref.addUserNote,
      isLoading = _ref.isLoading;
  return (0, _preact.h)(_inputUnit.default, {
    label: "Notes",
    error: errors ? errors.userNote : '',
    isControl: true
  }, userNotes.map(function (userNote, id) {
    var _userNote$userline$sp = userNote.userline.split(' on '),
        _userNote$userline$sp2 = (0, _slicedToArray2.default)(_userNote$userline$sp, 2),
        username = _userNote$userline$sp2[0],
        timestamp = _userNote$userline$sp2[1];

    var message = userNote.message;
    return (0, _preact.h)("div", {
      key: "userNote-".concat(id),
      className: "user-note"
    }, (0, _preact.h)("div", {
      className: "user-info"
    }, (0, _preact.h)("span", {
      className: "username"
    }, username), (0, _preact.h)("span", {
      className: "timestamp"
    }, timestamp)), (0, _preact.h)("p", {
      className: "note-text"
    }, message));
  }), (0, _preact.h)(_textArea.default, {
    value: userNoteInput,
    placeholder: "Add note...",
    onInputChange: onChangeUserNoteInput,
    isControl: true,
    size: "fullWidth",
    required: true
  }), (0, _preact.h)(_Button.default, {
    title: "Add Note",
    variant: "primary",
    isLoading: isLoading,
    onClick: addUserNote
  }));
};

var _default = UserNotes;
exports.default = _default;